import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Upload } from "lucide-react";
import { api } from "@/lib/api";

const CATS = ["A/V", "CCTV", "Networking", "Commercial"];

export function GalleryUploadForm({ onUploaded }) {
  const [form, setForm] = useState({ title: "", category: "A/V", subtitle: "", installed: true });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();
  const set = (k) => (e) => setForm({ ...form, [k]: k === "installed" ? e.target.checked : e.target.value });

  const upload = async (e) => {
    e.preventDefault();
    if (!file || !form.title) return toast.error("Add a photo and a title");
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("title", form.title); fd.append("category", form.category); fd.append("subtitle", form.subtitle); fd.append("installed", form.installed ? "true" : "false");
    try {
      await api.post("/admin/gallery", fd);
      toast.success("Photo added to gallery");
      setForm({ title: "", category: form.category, subtitle: "", installed: true }); setFile(null); if (fileRef.current) fileRef.current.value = "";
      onUploaded();
    } catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={upload} className="dg-card rounded-xl p-5 grid gap-4 sm:grid-cols-2" data-testid="gallery-upload-form">
      <div className="sm:col-span-2 dg-eyebrow flex items-center gap-2"><ImagePlus className="w-3 h-3" /> Add a project photo</div>
      <label className="block"><div className="dg-eyebrow mb-1">Title</div>
        <input className="dg-input" value={form.title} onChange={set("title")} placeholder="e.g. Living room 5.1 surround" data-testid="gallery-title-input" /></label>
      <label className="block"><div className="dg-eyebrow mb-1">Category</div>
        <select className="dg-input" value={form.category} onChange={set("category")} data-testid="gallery-category-select">
          {CATS.map((c) => <option key={c}>{c}</option>)}
        </select></label>
      <label className="block sm:col-span-2"><div className="dg-eyebrow mb-1">Short description (optional)</div>
        <input className="dg-input" value={form.subtitle} onChange={set("subtitle")} placeholder="What was done" data-testid="gallery-subtitle-input" /></label>
      <label className="block sm:col-span-2"><div className="dg-eyebrow mb-1">Photo (JPG/PNG/WEBP, under 15 MB)</div>
        <input ref={fileRef} type="file" accept="image/*" className="dg-input" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="gallery-file-input" />
        <div className="mt-1 text-xs text-slate-500" data-testid="gallery-quality-hint">Use the full-size photo from your phone (at least 1200 px wide). Tiny or out-of-focus photos are refused so the gallery never looks blurry.</div></label>
      <label className="sm:col-span-2 flex items-center gap-2 text-sm text-slate-300 cursor-pointer">
        <input type="checkbox" checked={form.installed} onChange={set("installed")} className="accent-cyan-500 w-4 h-4" data-testid="gallery-installed-checkbox" />
        Installed by David (shows an "Installed by David" tag on the photo)
      </label>
      <div className="sm:col-span-2">
        <button type="submit" disabled={busy} className="dg-btn-primary rounded-full px-6 py-2 text-sm flex items-center gap-2 disabled:opacity-50" data-testid="gallery-upload-btn">
          <Upload className="w-4 h-4" /> {busy ? "Uploading…" : "Upload photo"}
        </button>
      </div>
    </form>
  );
}
